window.$ = window.jQuery = require('jquery');
require('src/frontend/core/jquery.safe-ready')(window.$);
require('src/frontend/core/jquery.addons')(window.$);
require('src/frontend/old/groupon_modules/placeholder_field')(window.$);
